import { render } from "./EditContactInputsSection.vue?vue&type=template&id=421a9afb&scoped=true"
import script from "./EditContactInputsSection.vue?vue&type=script&lang=js"
export * from "./EditContactInputsSection.vue?vue&type=script&lang=js"

import "./EditContactInputsSection.vue?vue&type=style&index=0&id=421a9afb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421a9afb"]])

export default __exports__